/**
 * URL gốc backend (không kèm /api/v1).
 * - Dev: VITE_API_URL hoặc http://localhost:4520 khi chạy ở localhost.
 * - Production: để RỖNG = cùng origin — nginx đã proxy /api, /uploads, /socket.io
 *   về backend (xem deploy/nginx-chatmql-dev.conf). Không nhúng cứng tên miền.
 */
export const API_ORIGIN =
  (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ??
  (typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:4520'
    : '')

export const API_BASE = `${API_ORIGIN}/api/v1`

/** Trùng khóa với bản build cũ của ChatMQL để phiên đăng nhập dùng chung khi chuyển đổi. */
export const TOKEN_KEY = 'token'
export const REFRESH_KEY = 'refreshToken'

/**
 * Đường dẫn ảnh thương hiệu do backend trả về → URL dùng được ở đây.
 *
 * Backend trả hai loại: ảnh tĩnh của giao diện (`/favicon.png`,
 * `/assets/...`) và ảnh do máy chủ phục vụ (`/api/v1/platform/branding/...`).
 * Ở production hai loại này cùng origin nên dùng thẳng; còn khi chạy dev,
 * giao diện ở cổng khác backend, phải ghép thêm API_ORIGIN cho loại thứ hai —
 * ghép nhầm cho loại thứ nhất thì ảnh tĩnh đi hỏi backend và trả 404.
 */
export function urlThuongHieu(u?: string | null): string {
  if (!u) return ''
  if (!u.startsWith('/api/')) return u
  return `${API_ORIGIN}${u}`
}
